import { __awaiter, __decorate, __generator, __metadata } from "tslib";
import { All } from "../Memoize/All";
import { Result } from "../Result";
var Workers = (function () {
    function Workers(data, act) {
        this.data = data;
        this.act = act;
        this.results = [];
        this.jobIndex = 0;
    }
    Workers.perform = function (data, action, config) {
        return new Workers(data, action).perform(config !== null && config !== void 0 ? config : {});
    };
    Object.defineProperty(Workers.prototype, "jobCount", {
        get: function () {
            return this.data.length;
        },
        enumerable: false,
        configurable: true
    });
    Workers.prototype.perform = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            var acceptMoreJobs, timeout, job, worker;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        acceptMoreJobs = true;
                        if (args.acceptJobsUntilMS) {
                            setTimeout(function () { return (acceptMoreJobs = false); }, args.acceptJobsUntilMS);
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 6, 7]);
                        if (this.jobCount === 0) {
                            return [2, new WorkersResult(this)];
                        }
                        args.workers || (args.workers = 10);
                        this.workers = Array.from({ length: Math.min(args.workers, this.jobCount) }, function () { return new Worker(_this); });
                        job = void 0;
                        _a.label = 2;
                    case 2:
                        if (!(job = this.nextJob())) return [3, 4];
                        return [4, this.getWorker()];
                    case 3:
                        worker = _a.sent();
                        if (acceptMoreJobs) {
                            worker.accept(job, args.jobTimeoutMS);
                        }
                        else {
                            this.returnJob();
                            return [3, 4];
                        }
                        return [3, 2];
                    case 4: return [4, this.drainWorkers()];
                    case 5:
                        _a.sent();
                        return [2, new WorkersResult(this)];
                    case 6:
                        if (timeout) {
                            clearTimeout(timeout);
                        }
                        return [7];
                    case 7: return [2];
                }
            });
        });
    };
    Workers.prototype.returnJob = function () {
        this.jobIndex--;
    };
    Workers.prototype.nextJob = function () {
        var _this = this;
        if (this.jobIndex < this.jobCount) {
            var index_1 = this.jobIndex;
            var job = function () { return _this.act(_this.data[index_1]); };
            this.jobIndex++;
            return job;
        }
        return null;
    };
    Workers.prototype.drainWorkers = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2, Promise.all(this.workers.map(function (w) { return w.waitForFree(); }))];
            });
        });
    };
    Workers.prototype.getWorker = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2, Promise.race(this.workers.map(function (w) { return w.waitForFree(); }))];
            });
        });
    };
    return Workers;
}());
export { Workers };
var WorkersResult = (function () {
    function WorkersResult(workers) {
        this.workers = workers;
    }
    Object.defineProperty(WorkersResult.prototype, "unprocessed", {
        get: function () {
            return this.workers["data"].slice(this.workers["jobIndex"]);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WorkersResult.prototype, "values", {
        get: function () {
            var values = [];
            this.complete.forEach(function (r) { return r.tap(function (v) { return values.push(v); }); });
            return values;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WorkersResult.prototype, "errors", {
        get: function () {
            var errors = [];
            this.complete.forEach(function (r) {
                return r.tap(function (i) { return i; }, function (err) { return errors.push(err); });
            });
            return errors;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WorkersResult.prototype, "complete", {
        get: function () {
            return this.workers["results"];
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        All(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], WorkersResult.prototype, "unprocessed", null);
    __decorate([
        All(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], WorkersResult.prototype, "values", null);
    __decorate([
        All(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], WorkersResult.prototype, "errors", null);
    return WorkersResult;
}());
export { WorkersResult };
var Worker = (function () {
    function Worker(workers) {
        this.workers = workers;
    }
    Worker.prototype.accept = function (job, timeout) {
        var _this = this;
        var result = Result.fromPromise(job());
        if (timeout) {
            result = result.withTimeout(timeout);
        }
        result.then(function (r) { return _this.workers["results"].push(r); });
        this.current = result;
    };
    Worker.prototype.waitForFree = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (!this.current) {
                    return [2, this];
                }
                return [2, this.current.then(function () { return _this; })];
            });
        });
    };
    return Worker;
}());
